<template>
  <div class="wrap">
    <dd class="privacy_txt">
      <p>
        <span style="font-size: 16px">
          라온메타(이하 ‘회사’라 칭함)는 『개인정보보호법』에 관한 법규에 따라
          이용자의 개인정보 보호 및 권익을 보호하고, 개인정보와 관련된 이용자의
          고충을 원활하게 처리할 수 있도록 다음과 같은 개인정보 처리방침을
          수립하여 공개하고 있습니다.
        </span>
      </p>

      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제1조 (수집 및 처리하는 개인정보 항목 및 보유기간)
        </span>
      </p>

      <p>
        <span style="font-size: 16px">
          회사는 다음의 개인정보 항목을 수집 및 처리하고 있습니다.
        </span>
      </p>
      <table cellspacing="0" class="tab-1">
        <tbody>
          <tr>
            <td
              style="
                background-color: #d9d9d9;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-right: 1px solid black;
                border-top: 1px solid black;
                vertical-align: top;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">대구분</span>
                </span>
              </p>
            </td>
            <td
              style="
                background-color: #d9d9d9;
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: 1px solid black;
                vertical-align: top;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">소구분</span>
                </span>
              </p>
            </td>
            <td
              style="
                background-color: #d9d9d9;
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: 1px solid black;
                vertical-align: top;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">수집 항목</span>
                </span>
              </p>
            </td>
            <td
              style="
                background-color: #d9d9d9;
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: 1px solid black;
                vertical-align: top;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">수집 목적</span>
                </span>
              </p>
            </td>
            <td
              style="
                background-color: #d9d9d9;
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: 1px solid black;
                vertical-align: top;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">보유 기간</span>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'"> 문의 및 상담 </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      서비스 이용 문의
                    </span>
                  </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      문의 대응
                    </span>
                  </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      [필수] 이메일, 전화번호
                    </span>
                  </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      문의하기 대응 후 즉시 파기
                    </span>
                  </span>
                </span>
              </p>
            </td>
          </tr>

          <tr>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'"> 서비스 이용 </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      라온 메타데미
                    </span>
                  </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      [필수] 이름, 생년월일, 아이디, 휴대폰 번호,<br />
                      이메일, 소속(학교), 학번, 학과
                    </span>
                  </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      본인확인, 회원관리, 문의 대응, 회원의<br />
                      서비스 이용 통계
                    </span>
                  </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      서비스 해지 시 즉시 파기
                    </span>
                  </span>
                </span>
              </p>
            </td>
          </tr>

          <tr>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'"> 기타 </span>
                </span>
              </p>
            </td>
            <td
              colspan="4"
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: left; padding: 0px 10px">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    인터넷 서비스 이용과정에서 아래 개인정보 항목이 자동으로
                    생성되어 수집될 수 있습니다. <br />
                    - IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록
                  </span>
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <br />

      <ul>
        가) 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시․광고,
        계약내용 및 이행 등 거래에 관한 기록
        <li style="padding-left: 16px">① 표시․광고에 관한 기록: 6개월</li>
        <li style="padding-left: 16px">
          ② 계약 또는 청약철회, 대금결제, 재화 등의 공급기록: 5년
        </li>
        <li style="padding-left: 16px">
          ③ 소비자 불만 또는 분쟁처리에 관한 기록: 3년
        </li>
      </ul>

      <ul>
        나) 「통신비밀보호법」에 따른 통신사실확인자료 보관

        <li style="padding-left: 16px">
          ① 가입자 전기통신일시, 개시․종료시간, 상대방 가입자번호, 사용도수,
          발신기지국 위치추적자료 : 1년
        </li>
        <li style="padding-left: 16px">
          ② 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료 : 3개월
        </li>
      </ul>
      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제2조 (개인정보의 파기)
        </span>
      </p>
      <ul>
        <li style="padding-left: 16px">
          ① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가
          불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
        </li>
        <li style="padding-left: 16px">
          ② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이
          달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야
          하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나
          보관장소를 달리하여 보존합니다.
        </li>
        <li style="padding-left: 16px">
          ③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.

          <ul>
            <li style="padding-left: 16px">
              가) 파기절차: 회사는 파기 사유가 발생한 개인정보를 선정하고,
              회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
            </li>
            <li style="padding-left: 16px">
              나) 파기방법: 회사는 전자적 파일 형태로 기록․저장된 개인정보는
              기록을 재생할 수 없도록 파기하며, 종이 문서에 기록․저장된
              개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
            </li>
          </ul>
        </li>
      </ul>

      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제3조 (개인정보의 제3자 제공)
        </span>
      </p>

      <ul>
        <li style="padding-left: 16px">
          ① 회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한
          범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등
          『개인정보 보호법』 제17조 및 제18조에 해당하는 경우에만 개인정보를
          제3자에게 제공합니다.
        </li>
        <li style="padding-left: 16px">
          ② 회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.
        </li>
      </ul>

      <table cellspacing="0" class="tab-1">
        <tbody>
          <tr>
            <td
              style="
                background-color: #d9d9d9;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-right: 1px solid black;
                border-top: 1px solid black;
                vertical-align: top;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">제공받는 자</span>
                </span>
              </p>
            </td>
            <td
              style="
                background-color: #d9d9d9;
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: 1px solid black;
                vertical-align: top;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'"
                    >제공하는 개인정보 항목</span
                  >
                </span>
              </p>
            </td>
            <td
              style="
                background-color: #d9d9d9;
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: 1px solid black;
                vertical-align: top;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">제공목적</span>
                </span>
              </p>
            </td>
            <td
              style="
                background-color: #d9d9d9;
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: 1px solid black;
                vertical-align: top;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">보유 및 이용기간</span>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      NHN 한국사이버결제<br />
                      주식회사(KCP)
                    </span>
                  </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      성명, 생년월일, 카드사, 카드번호,<br />
                      유효기간, CVC, 통신사, 휴대폰번호
                    </span>
                  </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      신용카드 등의 결제 처리
                    </span>
                  </span>
                </span>
              </p>
            </td>
            <td
              style="
                border-bottom: 1px solid black;
                border-left: none;
                border-right: 1px solid black;
                border-top: none;
                vertical-align: middle;
              "
            >
              <p style="text-align: center">
                <span style="font-size: 10pt">
                  <span style="font-family: 'SCDream'">
                    <span style="font-weight: 700; text-decoration: underline">
                      목적 달성 시 파기<br />
                      (관련법에 따른 별도 저장 기간의 경우 KCP<br />
                      개인정보처리방침 참조)
                    </span>
                  </span>
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제4조 (개인정보처리의 위탁)
        </span>
      </p>

      <ul>
        <li style="padding-left: 16px">
          ① 회사는 개인정보 업무처리를 위해 개인정보 처리업무를 위탁하지
          않습니다.
        </li>
        <li style="padding-left: 16px">
          ② 회사는 위탁계약 체결 시 ｢개인정보 보호법｣에 따라 위탁업무 수행목적
          외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에
          대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에
          명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
        </li>
        <li style="padding-left: 16px">
          ③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보
          처리방침을 통하여 공개하도록 하겠습니다.
        </li>
      </ul>
      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제5조 (정보주체와 법정대리인의 권리/의무 및 행사방법)
        </span>
      </p>
      <ul>
        <li style="padding-left: 16px">
          ① 정보주체는 회사에 대해 언제든지 개인정보 열람․정정․삭제․처리정지
          요구 등의 권리를 행사할 수 있습니다.① 회사는 개인정보 업무처리를 위해
          개인정보 처리업무를 위탁하지 않습니다.
        </li>
        <li style="padding-left: 16px">
          ② 제1항에 따른 권리 행사는 회사에 대해 개인정보보호법 시행령
          제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수
          있으며, 회사는 이에 대해 지체없이 조치하겠습니다.
        </li>
        <li style="padding-left: 16px">
          ③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등
          대리인을 통하여 하실 수 있습니다. 이 경우 “개인정보 처리방법에 관한
          고시” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
        </li>
        <li style="padding-left: 16px">
          ④ 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조, 제37조에
          의하여 정보주체의 권리가 제한 될 수 있습니다.
        </li>
        <li style="padding-left: 16px">
          ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집
          대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.
        </li>
        <li style="padding-left: 16px">
          ⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구,
          처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한
          대리인인지를 확인합니다.
        </li>
      </ul>
      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제6조 (개인정보의 안전성 확보조치)
        </span>
      </p>

      <p>
        <span style="font-size: 16px">
          회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고
          있습니다.
        </span>
      </p>

      <ul>
        1. 관리적 조치

        <li style="padding-left: 16px">
          가) 내부관리계획 수립 및 시행. 개인정보 취급자 최소화, 정기적 직원교육
          시행① 정보주체는 회사에 대해 언제든지 개인정보 열람․정정․삭제․처리정지
          요구 등의 권리를 행사할 수 있습니다.① 회사는 개인정보 업무처리를 위해
          개인정보 처리업무를 위탁하지 않습니다.
        </li>
        <li style="padding-left: 16px">
          나) 개인정보 처리시스템에 대한 접근권한 부여, 변경, 말소를 통해
          접근통제
        </li>
      </ul>

      <ul>
        2. 기술적 조치

        <li style="padding-left: 16px">
          가) 개인정보처리시스템 등의 접근권한 관리
        </li>
        <li style="padding-left: 16px">
          나) 백신프로그램 및 다양한 보안솔루션 도입/운영
        </li>

        <li style="padding-left: 16px">
          다) 이용자 개인정보의 비밀번호에 의한 보호, 파일 및 전송 데이터 암호화
        </li>
        <li style="padding-left: 16px">
          라) 접속기록의 보관 및 위변조 방지 등
        </li>
      </ul>

      <ul>
        3. 물리적 조치

        <li style="padding-left: 16px">
          가) 주요 보호구역을 통제구역/제한구역으로 설정
        </li>
        <li style="padding-left: 16px">
          나) 사무실, 전산실 등 보호구역에 대한 비인가자 출입통제
        </li>
        <li style="padding-left: 16px">다) CCTV설치를 통한 모니터링 등</li>
      </ul>
      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제7조 (개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항)
        </span>
      </p>

      <ul>
        <li style="padding-left: 16px">
          ① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를
          저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.
        </li>
        <li style="padding-left: 16px">
          ② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터
          브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의
          하드디스크에 저장되기도 합니다.

          <ul>
            <li style="padding-left: 16px">
              가) 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에
              대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여
              이용자에게 최적화된 정보 제공을 위해 사용됩니다.
            </li>
            <li style="padding-left: 16px">
              나) 쿠키의 설치∙운영 및 거부: 웹브라우저 상단의 도구>인터넷
              옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수
              있습니다.
            </li>
            <li style="padding-left: 16px">
              다) 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할
              수 있습니다.
            </li>
          </ul>
        </li>
      </ul>
      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제8조 (개인정보 보호책임자)
        </span>
      </p>

      <ul>
        <li style="padding-left: 16px">
          ① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
          처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이
          개인정보 보호책임자를 지정하고 있습니다.
        </li>

        <li style="padding-left: 16px">
          <table cellspacing="0" class="tab-1">
            <tbody>
              <tr>
                <td
                  style="
                    background-color: #d9d9d9;
                    border-bottom: 1px solid black;
                    border-left: 1px solid black;
                    border-right: 1px solid black;
                    border-top: 1px solid black;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 10pt">
                      <span style="font-family: 'SCDream'">구분</span>
                    </span>
                  </p>
                </td>
                <td
                  style="
                    background-color: #d9d9d9;
                    border-bottom: 1px solid black;
                    border-left: none;
                    border-right: 1px solid black;
                    border-top: 1px solid black;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 10pt">
                      <span style="font-family: 'SCDream'"
                        >개인정보 보호책임자</span
                      >
                    </span>
                  </p>
                </td>
                <td
                  style="
                    background-color: #d9d9d9;
                    border-bottom: 1px solid black;
                    border-left: none;
                    border-right: 1px solid black;
                    border-top: 1px solid black;
                    vertical-align: top;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 10pt">
                      <span style="font-family: 'SCDream'"
                        >개인정보 보호관리자</span
                      >
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom: 1px solid black;
                    border-left: none;
                    border-right: 1px solid black;
                    border-top: none;
                    vertical-align: middle;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 10pt">
                      <span style="font-family: 'SCDream'"> 부서/이름 </span>
                    </span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom: 1px solid black;
                    border-left: none;
                    border-right: 1px solid black;
                    border-top: none;
                    vertical-align: middle;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 10pt">
                      <span style="font-family: 'SCDream'"> 윤원석 전무 </span>
                    </span>
                  </p>
                </td>
                <td
                  style="
                    border-bottom: 1px solid black;
                    border-left: none;
                    border-right: 1px solid black;
                    border-top: none;
                    vertical-align: middle;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 10pt">
                      <span style="font-family: 'SCDream'"> 차영록 팀장 </span>
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style="
                    border-bottom: 1px solid black;
                    border-left: none;
                    border-right: 1px solid black;
                    border-top: none;
                    vertical-align: middle;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 10pt">
                      <span style="font-family: 'SCDream'"> 이메일 </span>
                    </span>
                  </p>
                </td>
                <td
                  colspan="2"
                  style="
                    border-bottom: 1px solid black;
                    border-left: none;
                    border-right: 1px solid black;
                    border-top: none;
                    vertical-align: middle;
                  "
                >
                  <p style="text-align: center">
                    <span style="font-size: 10pt">
                      <span style="font-family: 'SCDream'">
                        privacy@raoncorp.com
                      </span>
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </li>

        <li style="padding-left: 16px">
          ② 정보주체는 회사의 서비스을 이용하시면서 발생한 모든 개인정보 보호
          관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및
          담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해
          지체없이 답변 및 처리해드릴 것입니다.
        </li>
      </ul>
      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제9조 (권익침해 구제방법)
        </span>
      </p>

      <p>
        <span style="font-size: 16px">
          정보주체는 개인정보침해로 인한 구제를 받기 위하여
          개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에
          분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의
          신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
        </span>
      </p>

      <ul>
        <li style="padding-left: 16px">
          1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972 <a href="https://www.kopico.go.kr/main/main.do" target="_blank">(www.kopico.go.kr)</a>
        </li>
        <li style="padding-left: 16px">
          2. 개인정보침해신고센터 : (국번없이) 118 <a href="https://privacy.kisa.or.kr/main.do" target="_blank">(privacy.kisa.or.kr)</a>
        </li>
        <li style="padding-left: 16px">
          3. 대검찰청 : (국번없이) 1301 <a href="https://www.spo.go.kr/site/spo/main.do" target="_blank">(www.spo.go.kr)</a>
        </li>
        <li style="padding-left: 16px">
          4. 경찰청 : (국번없이) 182 <a href="https://ecrm.police.go.kr" target="_blank">(https://ecrm.police.go.kr)</a>
        </li>
      </ul>

      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
          제10조 (영상정보처리기기 설치/운영)
        </span>
      </p>

      <p>
        <span style="font-size: 16px">
          회사는 아래와 같이 영상정보처리기기를 설치․운영하고 있습니다.
        </span>
      </p>

      <ul>
        <li style="padding-left: 16px"></li>
        <li style="padding-left: 16px">
          1. 영상정보처리기기 설치근거․목적 : 회사의 시설안전․화재예방
        </li>
        <li style="padding-left: 16px">
          2. 설치 대수, 설치 위치, 촬영 범위 : 사내 각층 및 주요시설물에 총 26대
          설치, 촬영범위는 주요시설물의 전 공간을 촬영
        </li>
        <li style="padding-left: 16px">
          3. 관리책임자, 담당부서 및 영상정보에 대한 접근권한자 : 경영기획본부
          박종원 본부장
        </li>

        <li style="padding-left: 16px">
          4. 영상정보 촬영시간, 보관기간, 보관장소, 처리방법

          <ul>
            <li style="padding-left: 16px">가) 촬영시간: 24시간 촬영</li>
            <li style="padding-left: 16px">나) 보관기간: 촬영시부터 60일</li>
            <li style="padding-left: 16px">
              다) 보관장소 및 처리방법 : 경영지원팀 영상정보처리기기 통제실에
              보관․처리
            </li>
          </ul>
        </li>
        <li style="padding-left: 16px">
          5. 영상정보 확인 방법 및 장소: 관리책임자에 요구 (경영지원팀)
        </li>
        <li style="padding-left: 16px">
          6. 정보주체의 영상정보 열람 등 요구에 대한 조치: 개인영상정보
          열람․존재확인 청구서로 신청하여야 하며, 정보주체 자신이 촬영된 경우
          또는 명백히 정보주체의 생명․신체․재산 이익을 위해 필요한 경우에 한해
          열람을 허용함
        </li>
        <li style="padding-left: 16px">
          7. 영상정보 보호를 위한 기술적․관리적․물리적 조치: 내부관리계획 수립,
          접근통제 및 접근권한 제한, 영상정보의 안전한 저장․전송기술 적용,
          처리기록 보관 및 위․변조 방지조치, 보관시설 마련 및 잠금장치 설치 등
        </li>
      </ul>

      <br />

      <p>
        <span
          style="
            font-size: 24px;
            font-weight: 700;
            display: block;
            margin-bottom: 16px;
          "
        >
        부칙
        </span>
      </p>
      
      <p style="font-size: 16px">
        회사의 개인정보 처리방침은 관련 법령 및 지침, 내부 개인정보 운영방침의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 시에는 지체없이 웹 사이트 등을 통하여 고지할 것입니다.
      </p>
      <br />
      <p style="font-size: 14px">개인정보 처리방침 버전번호: 1.0</p>
      <p style="font-size: 14px">개인정보 처리방침 시행일자: 2024. 05. 31</p>
    </dd>
  </div>
</template>

<script>
export default {
  name: 'privacyPolicyTxt',
  components: {},
  setup() {},
}
</script>

<style>
.privacy_txt {
  width: 1000px;
  padding: 100px 40px;
  margin: 0 auto;
}
.privacy_txt ul {
  counter-reset: number;
}

.privacy_txt ul .first_item {
  margin-left: 24px;
}

.privacy_txt ul .first_item::before {
  margin-left: -16px;
  counter-increment: number;
  content: '' counter(number) '. ';
}

.privacy_txt ul .number_item {
  font-size: 16px;
  margin-left: 24px;
}

.privacy_txt ul .number_item::before {
  margin-left: -24px;
  counter-increment: number;
  content: '' counter(number) ') ';
}
</style>
